import { GET_POSTS, GET_POSTS_SUCCESS, GET_POSTS_FAIL, GET_NOTICES } from '../actions/post';
const initialState = {
  startPage: 0,
  endPage: 0,
  isLast: false,
  posts: [],
  notices: [],
  postsLoading: true,
};

export default function postReducer(state = initialState, action) {
  switch (action.type) {
    case GET_POSTS:
      return {
        ...state,
        postsLoading: true,
      };
    case GET_POSTS_SUCCESS:
      return {
        ...state,
        startPage: action.data.start_page,
        endPage: action.data.end_page,
        isLast: action.data.is_last,
        posts: action.data.posts,
        postsLoading: false,
      };
    case GET_POSTS_FAIL:
      return {
        ...initialState,
        notices: state?.notices,
        postsLoading: false,
      };
    case GET_NOTICES:
      return {
        ...state,
        notices: action.data,
      };
    default:
      return state;
  }
}
